import { useState } from 'react';
import { categories, feedItems, type GuaItem } from '@/mocks/guatian';

function formatHeat(n: number) {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return String(n);
}

interface Props {
  onRead: (item: GuaItem) => void;
}

export default function Feed({ onRead }: Props) {
  const [active, setActive] = useState('全部');
  const list = active === '全部' ? feedItems : feedItems.filter((i) => i.category === active);

  return (
    <section id="feed" className="w-full bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-2 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
              <i className="ri-flashlight-line" aria-hidden="true" /> 实时捕捉
            </p>
            <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">最新爆料合集</h2>
          </div>

          {/* 分类切换 */}
          <div className="flex flex-wrap items-center gap-1 rounded-full border border-background-300 bg-background-50 p-1" role="tablist" aria-label="爆料分类">
            {categories.map((c) => {
              const isActive = active === c.key;
              return (
                <button
                  key={c.key}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  onClick={() => setActive(c.key)}
                  className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm transition ${
                    isActive
                      ? 'bg-primary-500 font-medium text-background-50'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  <i className={`${c.icon} text-[15px]`} aria-hidden="true" />
                  {c.key}
                </button>
              );
            })}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((item) => (
            <article
              key={item.id}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-3xl border border-background-200 bg-background-50 transition hover:-translate-y-1 hover:border-primary-200"
              onClick={() => onRead(item)}
            >
              <div className="relative aspect-[16/10] w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] font-medium text-primary-700">
                  <i className="ri-fire-line" aria-hidden="true" /> {item.tag}
                </span>
                <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 rounded-full bg-foreground-950/60 px-2.5 py-1 text-[11px] text-background-50 backdrop-blur">
                  <i className="ri-flashlight-fill" aria-hidden="true" /> {formatHeat(item.heat)}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="mb-2 flex items-center gap-2 text-xs">
                  <span className="rounded-md bg-secondary-200 px-2 py-0.5 font-medium text-secondary-900">{item.category}</span>
                  <span className="text-foreground-500">
                    <i className="ri-time-line mr-1" aria-hidden="true" />
                    {item.time}
                  </span>
                </div>
                <h3 className="line-clamp-2 text-[15px] font-semibold leading-snug text-foreground-950 transition group-hover:text-primary-700">
                  {item.title}
                </h3>
                <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-user-heart-line" aria-hidden="true" /> {item.author}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-chat-3-line" aria-hidden="true" /> {formatHeat(item.comment)} 讨论
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}